// src/store/ui/initial.js
import { IS_KIOSK } from '~/lib/constants'

const initialState = {
	confirm: null,
	dialog: null,
	shareDialog: null,
	errors: [], // [{ code, title, message }]
	isCSSPortrait: false, // CSS media query orientation (triggers rotation transform on mobile)
	prompt: null, // { id, title, message?, inputValue, inputPlaceholder?, action, destructive? }
	page: null,
	mouse_down: false,
	pending: false,
	textures: { status: 'idle', done: 0, total: 0 },
	rename: null,
	useCustomChannel: false, // dev only, not persisted
	// The mirror window is up; it paints this window's received stream. Not persisted.
	mirror_open: false,
	// The Output monitor is hidden while the mirror keeps the stream received. Only ever set while `mirror_open`. Not persisted.
	monitor_hidden: false,
	show: {
		ui: !IS_KIOSK,
		source: !IS_KIOSK,
		output: true,
		minimal: false,
		devices: false,
		presets: true,
		presets_grid: true,
		sources_grid: true,
		recordings_grid: true,
		images_grid: true,
		projects_grid: true,
		assets_grid: true,
		layers: true,
		projects: false,
		recordings: false,
		assets: false,
		// One param per row on every param surface; honoured only under the dock (`selectParamColumn`).
		param_column: true,
	},
	panels: {
		collapsed: {
			capture: false,
			effects: false,
			'effect:motion': true,
			'effect:control': true,
			'effect:inpaint': true,
			layers: true,
			'properties:surfaces': true,
			presets: false,
			projects: false,
			recordings: false,
			assets: false,
			devices: false,
		},
		sizes: {
			presets: 0.5457286432160804,
			layers: 0.12462311557788945,
			__scrollzone: 0.8723618090452261,
		},
		// Per BrowserPanel `context`: `{ grid, list }` in px, absent until the user ctrl+wheels.
		zoom: {},
	},
	// Open folds, keyed flat by id; holds only what is open. UI state only: never reaches a preset or the wire.
	folds: {},
	dock: {
		version: 1,
		layout: null,
		// Where a panel opens when the layout has no trace of it. Images joins Recordings even in a layout saved before it existed.
		placements: { images: { siblings: ['recordings'] } },
		collapsed: {},
		// The stage edge the drawing toolbar docks to: left | right | top | bottom.
		toolbar_side: 'top',
	},
}

export default initialState
